var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"error-page"}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"4"}},[_c('img',{attrs:{"src":"/img/error_404.jpg"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }